import React from "react";

import { StyledBox, StyledDot } from "./style";

const TypingLoader = () => {
  return (
    <StyledBox gap={0.5}>
      <StyledDot delay="0s" />
      <StyledDot delay="0.2s" />
      <StyledDot delay="0.4s" />
    </StyledBox>
  );
};

export default TypingLoader;
